"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiListChooserTitle = exports.MultiListChooserContent = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var multi_list_search_1 = require("../multi.list.search/multi.list.search");
var multi_list_chooser_style_1 = require("./multi.list.chooser.style");
var nested_list_chooser_state_1 = require("./nested.list.chooser.state");
var select_list_chooser_state_1 = require("./select.list.chooser.state");
(0, theme_1.addStyles)(multi_list_chooser_style_1.Style);
function focusNode(e) {
    setTimeout(function () { return e.dom.focus(); }, 10);
}
exports.MultiListChooserContent = {
    view: function (state) {
        var groupNodes = [];
        var filteredItemNodes = [];
        var groups = state.groups;
        if (state.hasError()) {
            return (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.container }, (0, i18n_1.Translate)(state.error));
        }
        if (groups == null) {
            return (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.container }, spinner_1.Spinner.view());
        }
        if (services_1.Services.MultiListSearch.inputfilterState.hasFilter()) {
            var flattenedEntryList = state.getAllOptions();
            var optionsValueKeyMap_1 = new Map(flattenedEntryList.map(function (x) { return [x.map(function (y) { return y.value; }).join(' > '), x.map(function (z) { return z.key; })]; }));
            var filteredEntryList = flattenedEntryList.map(function (x) { return x.map(function (y) { return y.value; }).join(' > '); }).filter(function (z) { return z.toLowerCase().includes(services_1.Services.MultiListSearch.inputfilterState.filter.toLowerCase()); });
            var _loop_1 = function (i) {
                var filteredEntry = filteredEntryList[i];
                var id = "filtered-list-item-".concat(i);
                var inputId = "".concat(id, "-input");
                var isSelected = state.value && state.value.join(' > ') === filteredEntry;
                var shouldFocus = i === 0 && isSelected;
                var filteredItemNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.selection, id: id }, [
                    (0, mithril_1.m)('input', {
                        type: 'radio',
                        id: inputId,
                        checked: isSelected ? 'checked' : null,
                        onchange: function () { return state.setValue(optionsValueKeyMap_1.get(filteredEntry)); },
                        oncreate: function () { return shouldFocus ? focusNode : null; }
                    }),
                    (0, mithril_1.m)('label', { for: inputId }, filteredEntry)
                ]);
                filteredItemNodes.push(filteredItemNode);
            };
            for (var i = 0; i < filteredEntryList.length; i++) {
                _loop_1(i);
            }
            var groupNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.container }, [
                (0, mithril_1.m)('label', { className: multi_list_chooser_style_1.CSS.group.title, for: name }, (0, i18n_1.Translate)(i18n_1.T.SEARCH_RES)),
                (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.selectionWrap }, filteredItemNodes)
            ]);
            groupNodes.push(groupNode);
        }
        else {
            var isColorField = false;
            if (
            // We have the correct token
            services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG)
                // And the field is one of the two list types which can have colors
                && (state instanceof select_list_chooser_state_1.SelectListChooserState || state instanceof nested_list_chooser_state_1.NestedListChooserState)
                // And this instance is the one that is marked as the color field
                && state.field.collection.schema.metadata.mapColorFieldId === state.field.schema.id) {
                isColorField = true;
            }
            for (var i = 0; i < groups.length; i++) {
                var group = groups[i];
                var name_1 = "multi-list-group-".concat(i);
                var itemNodes = [];
                var _loop_2 = function (j) {
                    var item = group.items[j];
                    var id = "".concat(name_1, "-").concat(j);
                    var inputId = "".concat(id, "-input");
                    var isSelected = group.selected === item.key;
                    var shouldFocus = i === 0 && isSelected;
                    var hasColor = item.color != null;
                    var stateValue = tslib_1.__spreadArray(tslib_1.__spreadArray([], groups.slice(0, i).map(function (g) { return g.selected; }), true), [item.key], false);
                    var children = [
                        (0, mithril_1.m)('input', {
                            type: 'radio',
                            id: inputId,
                            name: name_1,
                            checked: isSelected ? 'checked' : null,
                            onchange: function () { return state.setValue(stateValue); },
                            oncreate: shouldFocus ? focusNode : null
                        }),
                        (0, mithril_1.m)('label', { for: inputId }, item.value)
                    ];
                    if (isColorField && hasColor) {
                        children.push((0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.colorIndicator, style: { 'background-color': item.color } }));
                    }
                    itemNodes.push((0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.selection, id: id }, children));
                };
                for (var j = 0; j < group.items.length; j++) {
                    _loop_2(j);
                }
                if (itemNodes.length > 0) {
                    var groupNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.container }, [
                        (0, mithril_1.m)('label', { className: multi_list_chooser_style_1.CSS.group.title, for: name_1 }, group.title),
                        (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.group.selectionWrap }, itemNodes)
                    ]);
                    groupNodes.push(groupNode);
                }
            }
        }
        var chooserNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.chooserContainer }, groupNodes);
        var filterNode = new multi_list_search_1.MultiListSearch().nodes;
        var dialogNode = (0, mithril_1.m)('div', { className: multi_list_chooser_style_1.CSS.container }, [filterNode, chooserNode]);
        return dialogNode;
    }
};
exports.MultiListChooserTitle = {
    view: function (ctrl) {
        return (0, i18n_1.Translate)(i18n_1.T.SELECT, ctrl.label);
    }
};
//# sourceMappingURL=multi.list.chooser.js.map